import { render, staticRenderFns } from "./ChecklistDropdownFieldModule.vue?vue&type=template&id=d0326584&scoped=true"
import script from "./ChecklistDropdownFieldModule.vue?vue&type=script&setup=true&lang=ts"
export * from "./ChecklistDropdownFieldModule.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./ChecklistDropdownFieldModule.vue?vue&type=style&index=0&id=d0326584&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0326584",
  null
  
)

export default component.exports